// extracted by mini-css-extract-plugin
export default {"inputStyle":"form_inputStyle__1kHgl"};